import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { BaseService } from '@app/system/services/base.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from './utilities/services/api.service';

@Component({
	selector: 'app-registration-workflow',
	templateUrl: './registration-workflow.component.html',
	styleUrls: ['./registration-workflow.component.scss']
})
export class RegistrationWorkflowComponent implements OnInit {

	@Input() resourceDetail: any = {};
	@Input() popupRef;
	@Output() readLog = new EventEmitter();

	showRegisterLearning = false;
	showRequestRegistration = false;
	showRegister = false;
	showRequestApproval = false;
	showCancel = false;
	submitDisable = false;
	currentUser;

	constructor(
		public locale: LocaleService,
		private popup: MatDialog,
		private gfService: GlobalFunctionService,
		private apiService: ApiService,
		private baseService: BaseService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		if (this.resourceDetail && this.resourceDetail.infoFields) {
			if (this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key && this.resourceDetail.infoFields.startDate) {
				if (this.resourceDetail.resourceTypeID.key === 'internalEvent') {
					if (this.resourceDetail.infoFields.startDate && this.resourceDetail.infoFields.endDate) {
						const endDate: any = new Date(this.resourceDetail.infoFields.endDate);
						const timeDate = new Date(this.resourceDetail.infoFields.time);
						endDate.setHours(timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds(), timeDate.getMilliseconds());
						if (Date.now() > Date.parse(endDate)) {
							this.showRegisterLearning = true;
						}

						const startDate: any = new Date(this.resourceDetail.infoFields.startDate);
						startDate.setHours(timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds(), timeDate.getMilliseconds());
						if (Date.now() < Date.parse(startDate)) {
							this.showCancel = true;
						}
					}
					if (this.resourceDetail.infoFields.registerBy) {
						const today: any = new Date();
						today.setHours(0, 0, 0, 0);
						const date: any = new Date(this.resourceDetail.infoFields.registerBy);
						date.setHours(0, 0, 0, 0);
						if (Date.parse(today) < Date.parse(date)) {
							this.showRequestRegistration = true;
							this.showRegister = true;
						}
					}
				} else if (this.resourceDetail.resourceTypeID.key === 'externalEvent') {
					const today: any = new Date();
					today.setHours(0, 0, 0, 0);
					const date: any = new Date(this.resourceDetail.infoFields.startDate);
					date.setHours(0, 0, 0, 0);
					if (Date.parse(today) > Date.parse(date)) {
						this.showRegisterLearning = true;
					} else {
						this.showRequestApproval = true;
					}
				}
			}
		}
		if (this.resourceDetail && this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key === 'mooc') {
			this.showRequestApproval = true;
		}
	}

	register(actionEl) {
		// const dialogRef = this.popup.open(PopupComponent, {
		// 	panelClass: ['custom-panel'],
		// 	data: {
		// 		action: 'dynamic',
		// 		popup: true,
		// 		component: import('./registration-workflow-forms/registration-workflow-forms.component'),
		// 		componentData: [
		// 			{
		// 				variableName: 'action',
		// 				value: 'register'
		// 			},
		// 			{
		// 				variableName: 'record',
		// 				value: this.resourceDetail
		// 			}
		// 		],
		// 		triggerEl: actionEl
		// 	},
		// 	disableClose: true,
		// 	maxWidth: '860px'
		// });
		// dialogRef.afterClosed().subscribe((result) => {
		// 	if (result && typeof result === 'object') {
		// 		this.resourceDetail.registrationStatus = this.baseService.registrationStatus.find(items => items.key === 'registered');
		// 		this.resourceDetail.registrationID = result.recordID;
		// 		this.resourceDetail.registrationCount += 1;
		// 		if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
		// 			this.popupRef.componentInstance.dialogCloseData.updated = true;
		// 		}
		// 	}
		// });
		this.submitDisable = true;
		this.popupRef.componentInstance.popupLoader = true;
		const headers: any = {};
		const apiData: any = {
			resourceID: this.resourceDetail.resourceID,
			resourceTypeID: this.resourceDetail.resourceTypeID.value
		};
		this.apiService.register(apiData, headers).subscribe(
			(response) => {
				this.resourceDetail.registrationStatus = this.baseService.registrationStatus.find(items => items.key === 'registered');
				this.resourceDetail.registrationCount += 1;
				this.resourceDetail.registrationID = response.recordID;
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
				this.baseService.logUserActivity('register', 'learning', [''], { resourceData: this.resourceDetail });
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('registered'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				let errorMsg: string = error.error.message;
				if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === "DUPLICATE") {
					errorMsg = this.locale.translate('you_have_already_registered');
				}
				this.gfService.openSnackBar('ERROR', {
					message: errorMsg,
					icon: 'error',
					position: 'before'
				});
			}
		)
			.add(() => {
				this.submitDisable = false;
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

	requestRegistration(actionEl) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: import('./registration-workflow-forms/registration-workflow-forms.component'),
				componentData: [
					{
						variableName: 'action',
						value: 'requestRegistration'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.resourceDetail.registrationRequestStatus = this.baseService.registrationRequestStatus.find(items => items.key === 'pending');
				this.resourceDetail.registrationRequestCount += 1;
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
			}
		});
	}

	nominate(actionEl) {

	}

	registerLearning(actionEl) {
		let record: any = {
			issuingAuthority: (this.resourceDetail.infoFields) ? this.resourceDetail.infoFields.authority : null,
			date: (this.resourceDetail.infoFields && this.resourceDetail.resourceTypeID.key !== 'mooc') ? this.resourceDetail.infoFields.startDate : null,
			skills: this.resourceDetail.skills,
			title: this.resourceDetail.title,
			resourceID: this.resourceDetail.resourceID,
			resourceTypeID: this.resourceDetail.resourceTypeID.value,
			// registrationID: this.resourceDetail.registrationID
		};
		if (this.resourceDetail.registrationID) {
			record.registrationID = this.resourceDetail.registrationID;
		}
		if (this.resourceDetail.resourceTypeID.key === 'mooc') {
			record.activityType = 1;
		} else {
			record.activityType = 2;
		}
		let embedData: any = null;
		if (this.resourceDetail && this.resourceDetail.resource && this.resourceDetail.resourceTypeID.key === 'externalEvent') {
			embedData = this.resourceDetail.resource;
			embedData.title = this.resourceDetail.title;
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: import('@app/modules/people/people-forms/people-forms.component'),
				componentData: [
					{
						variableName: 'action',
						value: 'addCertification'
					},
					{
						variableName: 'userID',
						value: this.currentUser.userID
					},
					{
						variableName: 'record',
						value: record
					},
					{
						variableName: 'embedData',
						value: embedData
					}
				],
				triggerEl: actionEl
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				this.resourceDetail.registrationStatus = this.baseService.registrationStatus.find(items => items.key === 'registerLearning');
				this.readLog.emit(true);
			}
		});
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		const buttons = [
			{
				type: 'main-action',
				caption: this.locale.translate('yes'),
				key: 'yes'
			},
			{
				type: 'main-action',
				caption: this.locale.translate('no'),
				key: 'no',
				autoFocus: true
			}
		];
		let title = '';
		let content = '';
		if (action === 'cancelRegistration') {
			title = this.locale.translate('cancel');
			content = this.locale.translate('are_you_sure_you_want_cancel_the_registration');
		} else if (action === 'notAttend') {
			title = '';
			content = this.locale.translate('are_you_sure_you_did_not_attended');
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons,
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'cancelRegistration' || action === 'notAttend') {
						this.updateRegistrationStatus(action);
					}
				}
			}
		});
	}

	updateRegistrationStatus(action) {
		this.popupRef.componentInstance.popupLoader = true;
		const headers: any = {};
		let apiData: any = {
			resourceID: this.resourceDetail.resourceID,
			resourceTypeID: this.resourceDetail.resourceTypeID.value
		};
		let msg = '';
		let status;
		if (action === 'cancelRegistration') {
			const data = this.baseService.registrationStatus.find(items => items.key === 'cancel');
			apiData.status = data.value;
			status = data;
			msg = 'registration_cancelled';
		} else {
			const data = this.baseService.registrationStatus.find(items => items.key === 'noShow');
			apiData.status = data.value;
			status = data;
			msg = 'updated';
		}
		this.apiService.updateRegistrationStatus(apiData, this.resourceDetail.registrationID, headers).subscribe(
			(response) => {
				if (action === 'notAttend') {
					this.baseService.logUserActivity('didnotattend', 'engagement', [''], { resourceData: this.resourceDetail });
				} else if (action === 'cancelRegistration') {
					this.resourceDetail.registrationCount -= 1;
				}
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
				this.resourceDetail.registrationStatus = status;
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate(msg),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

}
